$(function() {
    $('.homepage-carousel__carousel').slick({
        arrows: false,
        autoplaySpeed: 8000,
        autoplay: true,
        dots: true,
        infinite: true
    });
});
